export const queries = {
  allEarnAndRedeems: `
  query {
    allEarnAndRedeems(where: { isActive: true }) {
      id
      heading
      subHeading
      isActive
      footerText
      items(where: { isActive: true }) {
        id
        heading
        subHeading
        isActive
        description
        imageEn {
          id
          isActive
          file {
            id
            filename
            publicUrl
          }
          name
        }
        imageFr {
          id
          isActive
          file {
            id
            filename
            publicUrl
          }
          name
        }
      }
    }
  }
`,
};
